package org.dronda.app.web.service

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Result
import com.github.michaelbull.result.onOk
import dev.whyoleg.cryptography.CryptographyProvider
import dev.whyoleg.cryptography.algorithms.SHA256
import dev.whyoleg.cryptography.random.CryptographyRandom
import io.ktor.http.URLBuilder
import io.ktor.http.URLProtocol
import io.ktor.http.path
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.io.bytestring.encodeToByteString
import org.dronda.app.web.client.AuthClient
import org.dronda.app.web.repository.AuthRepository
import org.dronda.application.config.BuildKonfig
import org.w3c.dom.get
import org.w3c.dom.set
import org.w3c.dom.url.URLSearchParams
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

class AuthService(
    private val authClient: AuthClient,
    private val authRepository: AuthRepository,
) {
    companion object {
        private val chars = (('A'..'Z') + ('a'..'z') + ('0'..'9') + '-' + '.' + '_' + '~').toCharArray()
        private const val CODE_VERIFIER_KEY = "CODE_VERIFIER"
        private const val INTENDED_ROUTE_KEY = "INTENDED_ROUTE"
    }

    suspend fun initiateAuthFlow() {
        if (authRepository.getValidAuthTokens() != null) {
            return
        }

        val searchParams = URLSearchParams(window.location.search)
        val authorizationCode = searchParams.get("authorization_code")
        val codeVerifier = window.sessionStorage[CODE_VERIFIER_KEY]

        if (authorizationCode == null || codeVerifier == null) {
            startLoginDance()
        } else {
            exchangeAuthCode(authorizationCode, codeVerifier)
        }
    }

    private suspend fun startLoginDance() {
        // Save the current route to return to after authentication
        val currentPath = window.location.pathname
        if (currentPath.isNotEmpty() && currentPath != "/") {
            window.sessionStorage[INTENDED_ROUTE_KEY] = currentPath
        }

        val challenge = generateCodeChallenge()
        val url = buildAuthUrl(challenge)
        window.location.href = url
    }

    @OptIn(ExperimentalEncodingApi::class)
    private suspend fun generateCodeChallenge(): String {
        val codeVerifier = CharArray(128) {
            chars[CryptographyRandom.nextInt(0, chars.size)]
        }.joinToString("")

        window.sessionStorage[CODE_VERIFIER_KEY] = codeVerifier

        val sha256Hasher = CryptographyProvider.Default.get(SHA256)
            .hasher()
        val sha256Hash = sha256Hasher.hash(codeVerifier.encodeToByteString())
        return Base64.encode(sha256Hash.toByteArray())
    }

    private fun buildAuthUrl(challenge: String): String {
        return URLBuilder(BuildKonfig.apiUrl).apply {
            protocol = URLProtocol.HTTPS
            path("a", "login")

            parameters.apply {
                append("response_type", "code")
                append("redirect_uri", BuildKonfig.appUrl)
                append("client_id", BuildKonfig.clientId)
                append("code_challenge", challenge)
                append("code_challenge_method", "S256")
            }
        }.toString()
    }


    private suspend fun exchangeAuthCode(authorizationCode: String, codeVerifier: String) {
        authClient.exchangeAuthorizationCode(
            codeVerifier = codeVerifier,
            authorizationCode = authorizationCode
        ).onOk {
            // Restore the intended route or default to /events
            val intendedRoute = window.sessionStorage[INTENDED_ROUTE_KEY] ?: "/events"
            window.sessionStorage.removeItem(INTENDED_ROUTE_KEY)

            // Update URL to the intended route without query parameters
            authRepository.setAuthTokens(it)
            delay(500)
            window.location.href = intendedRoute
//            window.history.replaceState(null, "", intendedRoute)
        }
    }
}